<template>
  <div></div>
  <router-view />
</template>
